<template>
  <v-form ref="form" v-model="valid" lazy-validation @close="close" @submit="submit" @submit.prevent="save">
    <v-card class="border">
      <v-card-title style="display: contents">
        <v-card class="card-header" style="box-shadow: none;">
          <span :class="{ 'text-h5' : !isDisplaySmall }">{{ message }}</span>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                v-bind="attrs"
                v-on="on"
                text
                x-large
                right
                class="btn__icon pa-0"
                style="position: absolute; right: 15px; height: 50%"
                width="18"
                @click="close"
              >
                <v-icon color="white">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Закрыть</span>
          </v-tooltip>
        </v-card>
      </v-card-title>

      <v-card class="card-icon" v-if="!isDisplaySmall">
        <v-icon class="custom-icon" color="white">{{ icon }}</v-icon>
      </v-card>

      <v-card-text>
        <v-row style="display: block; margin-left: 10%; margin-right: 10%; margin-top: 15px">
          <v-text-field
            v-model="telephone"
            label="Номер телефон"
            prepend-inner-icon="mdi-phone"
            type="phone"
            class=""
            outlined
            dense
            flat
            required
            @input="handlePhoneInput"
            :rules="[
              v => !!v || 'Поле обязательное для заполнения',
            ]"
            :maxlength="telephone.startsWith('+7') ? 16 : null"
          ></v-text-field>
          <v-text-field
            v-model="nameAbonent"
            label="Имя"
            prepend-inner-icon="mdi-rename"
            class=""
            outlined
            dense
            flat
            required
          ></v-text-field>
          <v-autocomplete
            v-if="isResComplex && !isService"
            v-model="addressDoorphone"
            :items="doorphones.map(d => d.address)"
            label="Адрес (Дом / Подъезд)"
            prepend-inner-icon="mdi-home-city"
            outlined
            dense
            clearable
            flat
            required
          ></v-autocomplete>
          <v-text-field
            v-if="isResComplex && addressDoorphone && !isService"
            v-model="apartmentNumber"
            label="Квартира"
            prepend-inner-icon="mdi-door"
            outlined
            dense
            flat
            required
            :rules="[
              v => !!v || 'Поле обязательно при выборе адреса'
            ]"
          ></v-text-field>
          <VehicleNumberInput
            :value="numberCar"
            label="Номер автомобиля"
            outlined
            dense
            @input="numberCar = $event"
          />
          <v-text-field
            v-model="comment"
            label="Комментарий"
            prepend-inner-icon="mdi-comment"
            outlined
            dense
            flat
            :disabled="isService"
          ></v-text-field>
          <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="190px"
            v-if="!isService"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="dateRange"
                label="Промежуток действия номера"
                outlined
                dense
                hide-details
                class="input input-search mb-4"
                v-on="on"
                prepend-inner-icon="mdi-calendar"
                readonly
              ></v-text-field>
            </template>
            <v-date-picker v-model="date" @click="menu = false" range :min="minDate" :max="maxDate">
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="menu = false">
                Назад
              </v-btn>
              <v-btn text color="primary" :disabled="!date[0]" @click="date = []">
                Сбросить
              </v-btn>
              <v-btn text color="primary" @click="menu = false">
                Выбрать
              </v-btn>
            </v-date-picker>
          </v-menu>
          <v-switch
            class="mt-0"
            v-model="notificationPassage"
            flat
            inset
            color="#85B285"
            label="Уведомление о проезде автомобиля"
          >
          </v-switch>
          <v-switch
            class="mt-0"
            v-model="isService"
            flat
            inset
            color="#85B285"
            label="Служебный транспорт"
          >
          </v-switch>
          <div style="display: block; text-align: center;">
            <v-btn
              outlined
              class="text-none mb-2 px-2 btn-code"
              rounded
              dark
              :disabled="!valid"
              @click="save"
            >
              Сохранить
            </v-btn>
          </div>
        </v-row>
      </v-card-text>

      <v-card-actions class="pt-0" style="display: contents">
        <v-card class="card-footer-dialog">
          <div style="display: grid; grid-template-columns: 10% 1fr;" class="pr-8 pb-3">
            <div>
              <v-icon style="font-size: 50px;" color="#87A1B9">mdi-information-outline</v-icon>
            </div>
            <div style="text-align: justify; font-family: Arial, sans-serif;">
              <p>
                <strong>Здесь вы можете создать временного абонента для шлагбаума.</strong>
              </p>
              <p>
                <br>Временный абонент не привязан к домофону и действует только для указанного шлагбаума.
                <br>Если вы укажете номер автомобиля, он автоматически будет добавлен в базу данных шлагбаума.
              </p>
              <p>
                <br>Вы можете указать промежуток времени для гостевого проезда. Если временной интервал будет указан,
                абонент и автомобильный номер будут действовать только в указанный промежуток времени.
              </p>
              <p>
                <br>Шлагбаумов может быть несколько. Например, в жилом комплексе.
              </p>
              <p v-if="isResComplex">
                <br><strong>Важно:</strong> Если абонент проживает в данном жилом комплексе, необходимо обязательно
                выбрать адрес и указать номер квартиры.
                Если абонент не является жителем комплекса, заполнение адреса не требуется.
              </p>
            </div>
          </div>
        </v-card>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import { mapActions } from 'vuex';
import formatPhoneNumberTextField from '../../mixins/formatPhoneNumberTextField';
import ruDateFormatMixin from '@/mixins/ruDateFormat';
import VehicleNumberInput from '@/components/VehicleNumberInput.vue';

export default {
  mixins: [formatPhoneNumberTextField, ruDateFormatMixin],
  components: { VehicleNumberInput },
  props: {
    active: {
      type: Boolean,
      required: true,
    },
    id: {
      type: Number,
    },
    message: {
      type: String,
    },
    icon: {
      type: String,
    },
    doorphones: {
      type: Array,
    },
    isResComplex: {
      type: Boolean,
      default: false,
    },
    editItem: {
      type: Object,
      default: null,
    },
  },
  data () {
    const today = new Date();

    return {
      valid: true,
      isDisplaySmall: false,
      notificationPassage: false,
      formValid: false,
      telephone: '',
      nameAbonent: '',
      numberCar: '',
      comment: '',
      isService: false,
      searchInput: '',
      selectedSubscriber: null,
      subscribers: [],
      addressDoorphone: '',
      apartmentNumber: '',
      filterAbonents: {},
      minDate: today.toISOString().substr(0, 10),
      date: [],
      menu: false,
    };
  },
  watch: {
    isService (val) {
      if (val) {
        this.comment = 'Служебный транспорт';
      } else {
        this.comment = '';
      }
    },
    editItem: {
      handler (val) {
        if (val) {
          this.loadEditData(val);
        }
      },
      immediate: true,
    },
    active (val) {
      if (val && this.editItem) {
        this.loadEditData(this.editItem);
      } else if (!val) {
        this.resetForm();
      }
    },
  },
  created () {
    window.addEventListener('resize', this.checkSize);
    this.checkSize();
    if (this.editItem) {
      this.loadEditData(this.editItem);
    }
  },
  computed: {
    dateRange () {
      const startDate = this.date && this.date[0] ? this.ruDateFormat(this.date[0], true) : '';
      const endDate = this.date && this.date[1] ? this.ruDateFormat(this.date[1], true) : '';

      if (startDate && endDate) {
        return `${startDate} - ${endDate}`;
      } else if (startDate) {
        return startDate;
      } else if (endDate) {
        return endDate;
      }
      return '';
    },
    maxDate () {
      const today = new Date();
      const max = new Date();
      const monthsToAdd = this.editItem ? 2 : 1;
      max.setMonth(today.getMonth() + monthsToAdd);
      return max.toISOString().substr(0, 10);
    },
  },
  methods: {
    ...mapActions({
      loadAbonents: 'Abonents/loadAbonents',
    }),
    handlePhoneInput (event) {
      const phoneValue = typeof event === 'string' ? event : (event.target?.value || event);
      this.telephone = this.formatPhoneNumberTextField(phoneValue);
    },
    checkSize () {
      this.isDisplaySmall = window.innerWidth <= 800;
    },
    async save () {
      this.$refs.form.validate();
      this.$nextTick(() => {
        if (this.valid) {
          const phoneNumberToSend = this.telephone.replace(/\D/g, '');
          this.close();

          // Если служебный транспорт
          const dateToSend = this.isService ? [] : this.date;
          const addressToSend = this.isService ? '' : this.addressDoorphone;
          const apartmentToSend = this.isService ? '' : this.apartmentNumber;

          if (this.editItem) {
            this.$emit(
              'update',
              this.editItem.id,
              'add',
              this.numberCar,
              this.notificationPassage,
              phoneNumberToSend,
              this.nameAbonent,
              this.comment,
              dateToSend,
              addressToSend,
              apartmentToSend,
            );
          } else {
            this.$emit(
              'save',
              'add',
              this.numberCar,
              this.notificationPassage,
              phoneNumberToSend,
              this.nameAbonent,
              this.comment,
              dateToSend,
              addressToSend,
              apartmentToSend,
            );
          }
        }
      });
    },
    loadEditData (item) {
      if (!item) return;
      if (item.telephone) {
        const phoneStr = item.telephone.toString();
        this.telephone = this.formatPhoneNumberTextField(phoneStr);
      } else {
        this.telephone = '';
      }
      this.nameAbonent = item.name || '';
      this.numberCar = item.car_number || '';
      this.comment = item.comment || '';
      this.notificationPassage = item.notification_passage || false;
      this.isService = item.comment === 'Служебный транспорт';

      if (item.address) {
        this.addressDoorphone = item.address;
      } else {
        this.addressDoorphone = '';
      }

      if (item.apartment) {
        this.apartmentNumber = item.apartment.toString();
      } else {
        this.apartmentNumber = '';
      }

      if (item.date_begin && item.date_end) {
        this.date = [item.date_begin, item.date_end];
      } else {
        this.date = [];
      }
    },
    resetForm () {
      this.nameAbonent = '';
      this.numberCar = '';
      this.addressDoorphone = '';
      this.telephone = '';
      this.comment = '';
      this.notificationPassage = false;
      this.isService = false;
      this.date = [];
      this.apartmentNumber = '';
    },
    async submit () {
      await this.$emit('submit');
    },
    async close () {
      await this.$emit('close');
      this.resetForm();
      this.$emit('update:active', false);
    },
  },
};
</script>

<style lang="scss" scoped>
.grid-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
}
.card-completion {
  display: flex;
}
.card-info {
  background-color: rgba(248, 248, 248, 0.35);
  color: black;
  width: auto;
  box-shadow: none;
}
.card-header {
  border-radius: 16px;
  text-align: center;
  height: 50px;
  padding-top: 10px;
  background-color: rgba(224, 179, 137, 0.5);
}
.custom-icon {
  font-size: 45px;
  height: 100%;
}
.card-icon {
  border-radius: 16px;
  top: 0;
  left: 0;
  position: absolute;
  width: 11%;
  height: 71px;
  max-height: 71px;
  text-align: center;
  background-color: #E0B389;
}
.card-footer-dialog {
  border-radius: 16px;
  text-align: center;
  padding-top: 10px;
  min-height: 100px;
  width: 100%;
  box-shadow: none;
  background-color: rgba(224, 179, 137, 0.5);
}
.btn-code {
  width: 100%;
  max-width: 250px;
  background-color: #E0B389;
  color: white;
}
.v-application p {
  margin-bottom: 0;
  font-family: 'Montserrat', sans-serif;
}
.box-2 {
  grid-column: 1 / 3;
}
.box-3 {
  grid-column: 1 / 3;
  grid-row: 4 / 5;
}
.border {
  border-radius: 16px;
}
.intercom-label {
  font-weight: 600;
  font-size: 14px;
  font-family: 'Montserrat', sans-serif;
}
.intercom-info {
  padding-left: 15px;
  font-weight: 400 !important;
  font-size: 14px;
  word-wrap: break-word;
  font-family: 'Montserrat', sans-serif;
}
.text-info {
  font-size: 15px;
}
@media screen and (max-width: 800px) {
  .card-header {
    margin-bottom: 30px;
  }
  .grid-container {
    display: block;
  }
  .card-completion {
    display: block;
  }
  .text-info {
    padding: 20px;
  }
}
@media screen and (max-width: 500px) {
  .code-designation {
    display: none;
  }
  v-card-title {
    padding: 0;
  }
}
@media screen and (max-width: 350px) {
  .v-text-field-like {
    width: 210px;
  }
}
</style>
